import {api, ReactQueryOptions} from 'lib/utils/api';

export function useQuote(options?: ReactQueryOptions['user']['quote']) {
    return api.user.quote.useQuery(undefined, options);
}
